export const supportedFileFormats = [
  ".aac",
  ".Amr",
  ".bmp",
  ".csv",
  ".doc",
  ".docx",
  ".Gif",
  ".jpeg",
  ".jpg",
  ".m3u",
  ".m4a",
  ".MOV",
  ".mp3",
  ".mp4",
  ".msg",
  ".msword",
  ".ogg",
  ".pdf",
  ".png",
  ".ppt",
  ".pptx",
  ".rar",
  ".tif",
  ".tiff",
  ".wav",
  ".xls",
  ".xlsx",
  ".xps",
  ".zip",
  ".txt"
];


 